export default "__VITE_ASSET__9ca74c41__"